import { Container } from '@hover/blueprint';
import React, { useState } from 'react';
import { Layout } from '../../v2/components/common';
import {
  Hero,
  FloatingLinks,
  HeaderDescription,
  OurValues,
  OurPeople,
  OurTools,
  CareerOpenJobs,
  FAQ,
  ContactUs,
} from '../../v2/components/careers';

const Careers: React.FC = () => {
  const [currentSection, setCurrentSection] = useState<string>('Our Values');

  return (
    <Layout
      title="Job Opportunities"
      description="HOVER is building the future of 3D property data. We are a small team that works hard and loves to celebrate our wins."
      isNavbarWhite={false}
      navbarBackgroundColor="brandNavy.500"
    >
      <Hero />
      <Container
        maxW="100%"
        position="relative"
        overflow="visible"
        alignItems="center"
        px={0}
      >
        <FloatingLinks
          currentSection={currentSection}
          setCurrentSection={setCurrentSection}
        />
        <HeaderDescription setCurrentSection={setCurrentSection} />
        <OurValues setCurrentSection={setCurrentSection} />
        <OurPeople setCurrentSection={setCurrentSection} />
        <OurTools setCurrentSection={setCurrentSection} />
        <CareerOpenJobs setCurrentSection={setCurrentSection} />
        <FAQ setCurrentSection={setCurrentSection} />
      </Container>
      <ContactUs />
    </Layout>
  );
};

export default Careers;
